import * as React from 'react';
import { observer } from 'mobx-react';

// Styles
const s = require('./FullScreenMessage.css');

// Props
interface IFullScreenMessageProps {
    className?: string;
    label: string;
    dismiss?: {
        label?: string;
        onClick: ((e: React.MouseEvent<HTMLButtonElement>) => void) | null;
    }
}

// Component
@observer
export class FullScreenMessage extends React.Component<IFullScreenMessageProps, {}> {
    static get defaultProps(): Partial<IFullScreenMessageProps> {
        return {
            className: null,
            dismiss: {
                label: 'Dismiss',
                onClick: null,
            },
        };
    }

    constructor(props: IFullScreenMessageProps) {
        super(props);
    }

    public render() {
        return (
            <div className={s.container}>
                <h5 className={s.message}>{this.props.label}</h5>

                {(this.props.dismiss.onClick && this.props.dismiss.label) && (
                    <button
                        className={s.dismiss}
                        onClick={this.props.dismiss.onClick}
                    >
                        {this.props.dismiss.label}
                        <hr />
                    </button>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/content/FullScreenMessage.tsx